"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCloseWorkflow = exports.setOpenWorkflow = exports.closeConfirmationModal = exports.showConfirmationModal = exports.setVersions = exports.setVersionComments = exports.setTab = exports.setOpenDrawer = exports.setLoadingVersionComments = exports.setIsLoadingKeyDocument = exports.setIsLoadingAssetDetail = exports.setIsDirty = exports.setIsCommentEditorDirty = exports.setIsAdvancedPanelOpened = exports.setIsAdvancedPanelCreated = exports.setAssetTags = exports.setAsset = exports.assetDetailSlice = exports.initialState = exports.onToggleKeyDocument = exports.assignUserNotificationCallback = exports.setReassignReviewerWorkflow = exports.toggleAdvancedTicketDetails = exports.loadAndPopulateParentTaskGroups = exports.setAssetKeyDocument = exports.deleteAssetTag = exports.saveAssetTags = exports.fetchAssetDetail = exports.TabTypes = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const toolkit_1 = require("@reduxjs/toolkit");
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const jquery_1 = __importDefault(require("jquery"));
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const helpers_1 = require("../helpers");
const ticketHistorySlice_1 = require("./ticketHistorySlice");
const task_store_1 = __importDefault(require("../../../js/tasks/task-store"));
var TabTypes;
(function (TabTypes) {
    TabTypes[TabTypes["PREVIEW_TAB"] = 0] = "PREVIEW_TAB";
    TabTypes[TabTypes["ASSET_DETAIL_TAB"] = 1] = "ASSET_DETAIL_TAB";
    TabTypes[TabTypes["VERSION_TAB"] = 2] = "VERSION_TAB";
    TabTypes[TabTypes["WORKFLOW_TAB"] = 3] = "WORKFLOW_TAB";
})(TabTypes = exports.TabTypes || (exports.TabTypes = {}));
exports.fetchAssetDetail = (0, toolkit_1.createAsyncThunk)('asset/fetchById', async ({ assetId, ticketId }, { dispatch }) => {
    let endpoint = `${window.pulse.config.urls.app}api/assets`;
    if (assetId) {
        if (Array.isArray(assetId)) {
            endpoint += `?${qs_1.default.stringify({ 'filter[assetid][]': [assetId] }, { arrayFormat: 'repeat' })}`;
        }
        else {
            endpoint += `/${assetId}`;
        }
    }
    const assetDetail = await pulse_components_1.v2Endpoint
        .get(endpoint, {
        params: (0, helpers_1.getAssetDetailParams)(ticketId),
    })
        .then((response) => {
        const { data } = response;
        const normalisedAssetData = (0, helpers_1.getAssetDetailResponse)(data);
        return normalisedAssetData;
    })
        .catch(() => {
        utilities_1.default.unblockPage();
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger('Failed to fetch asset detail');
    });
    return assetDetail;
});
exports.saveAssetTags = (0, toolkit_1.createAsyncThunk)('asset/saveTag', async ({ assetId, tags }) => {
    const params = {
        action: 'files',
        type: 'addTags',
        assetId,
        tags,
    };
    const newTags = await pulse_components_1.v2Endpoint
        .get(window.pulse.config.urls.api, { params })
        .then((response) => {
        utilities_1.default.notification.success('Asset tags updated');
        return response.data.data.map((tag) => {
            return {
                label: tag.tagValue,
                value: tag.tagId.toString(),
            };
        });
    })
        .catch(() => {
        utilities_1.default.notification.warning('Failed to save asset tags.');
    });
    return newTags;
});
exports.deleteAssetTag = (0, toolkit_1.createAsyncThunk)('asset/deleteTag', async ({ assetId, tag }) => {
    if (!tag) {
        return '';
    }
    const params = {
        action: 'files',
        type: 'removeTags',
        assetId,
        tagId: tag.value,
    };
    const tagId = await pulse_components_1.v2Endpoint
        .get(window.pulse.config.urls.api, { params })
        .then((response) => {
        if (response.data.success) {
            return tag.value;
        }
        throw new Error('Failed to delete the tag');
    });
    return tagId;
});
exports.setAssetKeyDocument = (0, toolkit_1.createAsyncThunk)('asset/setKeyDocument', async ({ isKeyDocument, assetId }) => {
    const response = await pulse_components_1.v2Endpoint
        .post(`${window.pulse.config.urls.app}asset/toggle-key-document/${assetId}`, {
        state: +isKeyDocument,
    })
        .then((res) => {
        return res.data;
    });
    return response;
});
exports.loadAndPopulateParentTaskGroups = (0, toolkit_1.createAsyncThunk)('ticket/loadParentGroups', (payload, { getState }) => {
    const { ticket: { data: ticketData }, } = getState();
    const ticket = ticketData;
    const { parent } = ticket || {};
    const $select = (0, jquery_1.default)('select[data-property="parentTaskGroup.id"]');
    $select.html(`<option value="" disabled="disabled">Loading...</option>`);
    let html = '';
    const endPoint = helpers_1.URLS.api;
    const params = jquery_1.default.param({
        action: 'tasks',
        type: 'get-parent-task-group-for-task',
        task: ticket === null || ticket === void 0 ? void 0 : ticket.ticketid,
    });
    jquery_1.default.get(endPoint, params)
        .done(({ data: parentTaskGroups }) => {
        jquery_1.default.each(parentTaskGroups, (type, types) => {
            let divider = '';
            let selected = '';
            let treeDepth = '';
            if (types.length) {
                switch (type) {
                    case 'activeParent':
                        divider = `SELECT AN EXISTING TASK GROUP`;
                        break;
                    case 'activeAllTaks':
                        divider = `SELECT FROM ALL TASKS`;
                        break;
                    case 'inactiveParentTasks':
                        divider = `CLOSED TASK GROUPS`;
                        break;
                    default:
                        divider = 'None';
                }
                html += `<option class="divider" value="" disabled="disabled">--- ${divider} ---</option>`;
                jquery_1.default.each(types, (i, t) => {
                    if (type === 'activeParent') {
                        if (parent && parent.ticketid == t.ticketid) {
                            selected = `selected="selected"`;
                        }
                        else {
                            selected = ``;
                        }
                    }
                    if (t.treeDepth === 1) {
                        treeDepth = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                    }
                    else if (t.treeDepth === 2) {
                        treeDepth = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                    }
                    else {
                        treeDepth = '';
                    }
                    if (t.startdate) {
                        html += `<option value="${t.value}" ${selected}>${treeDepth}${t.title} (${t.startdate} - ${t.enddate})</option>`;
                    }
                    else {
                        html += `<option value="${t.value}" ${selected}>${treeDepth}${t.title}</option>`;
                    }
                });
            }
        });
        html = `<option value="">None</option>${html}`;
        $select.html(html);
    })
        .fail(() => {
        html = '<option value="" selected="selected">None</option>';
        $select.html(html);
    });
});
const createAdvancedPanel = (0, toolkit_1.createAsyncThunk)('ticket/createAdvancedPanel', (payload, { dispatch, getState }) => {
    var _a, _b;
    const { assetDetail: { asset, isOpenAdvanceDetails }, ticketHistory: { showTicketHistoryPanel }, } = getState();
    let task = (_a = asset === null || asset === void 0 ? void 0 : asset.note) === null || _a === void 0 ? void 0 : _a.ticket;
    task = {
        ...task,
        display: {
            general: (task === null || task === void 0 ? void 0 : task.display_to_general) === 'y',
            vendor: (task === null || task === void 0 ? void 0 : task.display_to_vendor) === 'y',
            client: (task === null || task === void 0 ? void 0 : task.display_to_client) === 'y',
            calendar: (task === null || task === void 0 ? void 0 : task.visible_on_calendar) === 'y',
        },
        job: {
            ...asset === null || asset === void 0 ? void 0 : asset.job,
        },
        forecastEffortHours: task === null || task === void 0 ? void 0 : task.forecast_effort,
        kpi: (task === null || task === void 0 ? void 0 : task.is_kpi) === 'y',
        assignUsersToNextTaskOnCompletion: (task === null || task === void 0 ? void 0 : task.assign_to_next_task) === 'y',
        maxRoundsAllowed: task === null || task === void 0 ? void 0 : task.max_rounds_allowed,
        type: {
            ...task === null || task === void 0 ? void 0 : task.type,
            colour: (_b = task === null || task === void 0 ? void 0 : task.type) === null || _b === void 0 ? void 0 : _b.color,
        },
    };
    let canEditRoundsAmount = false;
    if (helpers_1.CURRENT_USER.category === 'Operations' ||
        helpers_1.CURRENT_USER.category === 'Project Manager' ||
        (task === null || task === void 0 ? void 0 : task.reported_by) === helpers_1.CURRENT_USER.id) {
        // check for 'manageTasks' permission
        // to match the server-side permissions
        if (helpers_1.CURRENT_USER.manageTasks === 'y') {
            canEditRoundsAmount = true;
        }
    }
    jquery_1.default.ajax({
        url: `${helpers_1.URLS.api}?action=rounds&type=get&ticketid=${task === null || task === void 0 ? void 0 : task.ticketid}`,
        async: false,
        dataType: 'json',
        success(data) {
            jquery_1.default.each(data.data.rounds, (index, round) => {
                if (round.status === 'in-progress') {
                    canEditRoundsAmount = false;
                }
            });
        },
    });
    // Populate parent task groups
    dispatch((0, exports.loadAndPopulateParentTaskGroups)());
});
exports.toggleAdvancedTicketDetails = (0, toolkit_1.createAsyncThunk)('ticket/toggleAdvancePanel', (payload, { dispatch, getState }) => {
    const { assetDetail: { isAdvancedPanelCreated }, ticketHistory: { showTicketHistoryPanel }, } = getState();
    if (!isAdvancedPanelCreated) {
        dispatch(createAdvancedPanel({}));
    }
    if (showTicketHistoryPanel) {
        dispatch((0, ticketHistorySlice_1.closeTicketHistory)({}));
    }
    (0, jquery_1.default)('#advanced-task-details').slideToggle();
});
exports.setReassignReviewerWorkflow = (0, toolkit_1.createAsyncThunk)('asset/reassignReviewers', async ({ assignTasks, assignees, stakeholders, userIds, groupIds }, { dispatch, getState }) => {
    const { assetDetail } = getState();
    const { asset } = assetDetail;
    const taskStore = new task_store_1.default(helpers_1.CONFIG, {});
    taskStore
        .updateTaskUserAssignments(assignTasks, assignees, stakeholders, 1, userIds.notify, groupIds.notify, false)
        .then(() => {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.success('The selected users have been reassigned successfully.');
    })
        .catch(() => {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger('The selected users have been reassigned failed.');
    });
});
exports.assignUserNotificationCallback = (0, toolkit_1.createAsyncThunk)('asset/assignUserNotificationCallback', async ({ userIds, groupIds }, { dispatch, getState }) => {
    var _a, _b, _c;
    const { assetDetail } = getState();
    const { asset } = assetDetail;
    const assignees = [];
    lodash_1.default.each(userIds.assign, (userId) => assignees.push({ id: userId, type: 'user' }));
    lodash_1.default.each(userIds.assign, (userId) => assignees.push({ id: userId, type: 'user' }));
    const stakeholders = userIds.follow.map((userId) => {
        return { id: userId, type: 'user' };
    });
    const assignTasks = (_b = (_a = asset === null || asset === void 0 ? void 0 : asset.note) === null || _a === void 0 ? void 0 : _a.ticket) === null || _b === void 0 ? void 0 : _b.ticketid;
    if (userIds.invite.length) {
        const endPoint = helpers_1.URLS.api;
        const postParams = {
            action: 'job-team',
            type: 'invite_users',
            jobId: (_c = asset === null || asset === void 0 ? void 0 : asset.job) === null || _c === void 0 ? void 0 : _c.id,
            id: userIds.invite,
        };
        jquery_1.default.ajax({
            type: 'POST',
            url: endPoint,
            data: postParams,
        }).done((res) => {
            if (!res.success) {
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.danger('There was an error add users to this project. <br />Please try again');
            }
            else {
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.success('The selected users have been added to this project.');
                dispatch((0, exports.setReassignReviewerWorkflow)({
                    assignTasks,
                    assignees,
                    stakeholders,
                    userIds,
                    groupIds,
                }));
            }
        });
    }
    else {
        dispatch((0, exports.setReassignReviewerWorkflow)({
            assignTasks,
            assignees,
            stakeholders,
            userIds,
            groupIds,
        }));
    }
});
exports.onToggleKeyDocument = (0, toolkit_1.createAsyncThunk)('asset/toggleDocument', async ({ isKeyDocument, renderFilesStructure }, { dispatch, getState }) => {
    const { assetDetail } = getState();
    const { asset } = assetDetail;
    jquery_1.default.post({
        url: `${helpers_1.URLS.app}asset/togge-key-document/${asset === null || asset === void 0 ? void 0 : asset.assetId}`,
        data: {
            state: isKeyDocument ? 1 : 0,
        },
    })
        .done((res) => {
        utilities_1.default.dismissNotifications();
        if (res === '1') {
            utilities_1.default.notification.success('Asset has been made a key document');
        }
        else if (res === '0') {
            utilities_1.default.notification.success('Asset is no longer a key document');
        }
        else {
            throw new Error();
        }
        (0, isFunction_1.default)(renderFilesStructure) && renderFilesStructure();
        dispatch((0, exports.setAssetKeyDocument)(res));
    })
        .fail(() => {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger('An error has occurred and the asset has not been updated');
    });
});
exports.initialState = {
    isDirty: false,
    ziflow: null,
    isZiflow: false,
    isOpenDrawer: false,
    isLoadingAssetDetail: false,
    // comments
    isLoadingComments: true,
    isCommentEditorDirty: false,
    comments: [],
    // asset
    asset: null,
    isLoadingKeyDocument: false,
    activeTab: TabTypes.PREVIEW_TAB,
    // advance feature
    isOpenHistory: false,
    isAdvancedPanelCreated: false,
    isOpenAdvanceDetails: false,
    isOpenWorkFlowTabs: false,
    isOpenAssetDetailsTabs: false,
    isConfirmationModalVisible: false,
};
exports.assetDetailSlice = (0, toolkit_1.createSlice)({
    name: 'AssetDetail',
    initialState: exports.initialState,
    reducers: {
        setIsLoadingAssetDetail: (state, action) => {
            state.isLoadingAssetDetail = action.payload;
        },
        setIsDirty: (state, action) => {
            state.isDirty = action.payload;
        },
        setIsAdvancedPanelOpened: (state, action) => {
            state.isOpenAdvanceDetails = action.payload;
        },
        setIsAdvancedPanelCreated: (state, action) => {
            state.isAdvancedPanelCreated = action.payload;
        },
        setOpenDrawer: (state, action) => {
            state.isOpenDrawer = action.payload;
            if (!action.payload) {
                state.asset = null;
                state.isDirty = false;
            }
        },
        setIsCommentEditorDirty: (state, action) => {
            state.isCommentEditorDirty = action.payload;
        },
        setAsset: (state, action) => {
            state.asset = action.payload;
        },
        setTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setAssetTags: (state, action) => {
            if (!state.asset) {
                return;
            }
            state.asset.tags = action.payload;
        },
        setIsLoadingKeyDocument: (state) => {
            state.isLoadingKeyDocument = true;
        },
        showConfirmationModal: (state) => {
            state.isConfirmationModalVisible = true;
        },
        closeConfirmationModal: (state) => {
            state.isConfirmationModalVisible = false;
        },
        setOpenWorkflow: (state) => {
            state.isOpenWorkFlowTabs = true;
        },
        setCloseWorkflow: (state) => {
            state.isOpenWorkFlowTabs = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(exports.fetchAssetDetail.pending, (state) => {
            state.isLoadingAssetDetail = true;
            state.isOpenDrawer = true;
        });
        builder.addCase(exports.fetchAssetDetail.fulfilled, (state, action) => {
            state.isLoadingAssetDetail = false;
            state.isOpenDrawer = true;
            state.asset = action.payload;
        });
        builder.addCase(exports.fetchAssetDetail.rejected, (state) => {
            state.isLoadingAssetDetail = false;
        });
        builder.addCase(exports.saveAssetTags.pending, (state) => {
            state.isLoadingAssetDetail = true;
        });
        builder.addCase(exports.saveAssetTags.fulfilled, (state, action) => {
            var _a;
            state.isLoadingAssetDetail = false;
            if ((_a = state.asset) === null || _a === void 0 ? void 0 : _a.tags) {
                state.asset.tags = action.payload;
            }
        });
        builder.addCase(exports.saveAssetTags.rejected, (state) => {
            state.isLoadingAssetDetail = false;
        });
        builder.addCase(exports.deleteAssetTag.fulfilled, (state, action) => {
            var _a;
            if (!((_a = state.asset) === null || _a === void 0 ? void 0 : _a.tags) || !action.payload) {
                return;
            }
            state.asset.tags = state.asset.tags.filter((tag) => { var _a; return tag.value.toString() !== ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.toString()); });
        });
        builder.addCase(exports.setAssetKeyDocument.pending, (state) => {
            state.isLoadingKeyDocument = true;
        });
        builder.addCase(exports.setAssetKeyDocument.fulfilled, (state, action) => {
            state.isLoadingKeyDocument = false;
            if (!state.asset) {
                return;
            }
            state.asset.keyDocument = action.payload;
        });
        builder.addCase(exports.setAssetKeyDocument.rejected, (state) => {
            state.isLoadingKeyDocument = false;
            utilities_1.default.notification.danger('Failed to update key document');
        });
        builder.addCase(exports.toggleAdvancedTicketDetails.fulfilled, (state) => {
            console.log(state.isOpenAdvanceDetails);
            state.isOpenAdvanceDetails = !state.isOpenAdvanceDetails;
        });
        builder.addCase(createAdvancedPanel.fulfilled, (state) => {
            state.isAdvancedPanelCreated = true;
        });
    },
});
_a = exports.assetDetailSlice.actions, exports.setAsset = _a.setAsset, exports.setAssetTags = _a.setAssetTags, exports.setIsAdvancedPanelCreated = _a.setIsAdvancedPanelCreated, exports.setIsAdvancedPanelOpened = _a.setIsAdvancedPanelOpened, exports.setIsCommentEditorDirty = _a.setIsCommentEditorDirty, exports.setIsDirty = _a.setIsDirty, exports.setIsLoadingAssetDetail = _a.setIsLoadingAssetDetail, exports.setIsLoadingKeyDocument = _a.setIsLoadingKeyDocument, exports.setLoadingVersionComments = _a.setLoadingVersionComments, exports.setOpenDrawer = _a.setOpenDrawer, exports.setTab = _a.setTab, exports.setVersionComments = _a.setVersionComments, exports.setVersions = _a.setVersions, exports.showConfirmationModal = _a.showConfirmationModal, exports.closeConfirmationModal = _a.closeConfirmationModal, exports.setOpenWorkflow = _a.setOpenWorkflow, exports.setCloseWorkflow = _a.setCloseWorkflow;
exports.default = exports.assetDetailSlice.reducer;
